import { render, staticRenderFns } from "./PwaPopup.vue?vue&type=template&id=06438912&scoped=true&"
import script from "./PwaPopup.vue?vue&type=script&lang=js&"
export * from "./PwaPopup.vue?vue&type=script&lang=js&"
import style0 from "./PwaPopup.vue?vue&type=style&index=0&id=06438912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06438912",
  null
  
)

export default component.exports